/**
 * Like identity helpers
 *
 * Frappe's `_liked_by` typically stores user identifiers (often email, sometimes username).
 * Our auth payload may provide either/both. This helper normalizes the candidate IDs we should
 * consider when determining "liked" state or when removing a like.
 */

export function getCandidateLikeUserIds(
  currentUser: { email?: unknown; name?: unknown } | null | undefined,
): string[] {
  const ids = [currentUser?.email, currentUser?.name]
    .filter((v): v is string => typeof v === "string" && v.trim().length > 0)
    .map((v) => v.trim());

  return Array.from(new Set(ids));
}

